import TooltipOne from '../../TooltipOne/TooltipOne.component';

interface MessageCellProps {
  isRead?: boolean;
  withEllipsis?: boolean;
  width?: string;
  smallerFont?: boolean;
  isTooltip?: boolean;
}

const MessageCell: React.FC<MessageCellProps> = (props) => {
  return (
    <TooltipOne title={props.isTooltip ? (props.children as string) : ''} placement='top'>
      <div
        style={{
          width: props.width,
          fontWeight: props.isRead === false ? 'bold' : undefined,
          textOverflow: props.withEllipsis ? 'ellipsis' : undefined,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          fontSize: props.smallerFont ? '0.8rem' : undefined,
        }}
      >
        {props.children}
      </div>
    </TooltipOne>
  );
};

export default MessageCell;
